import { type UUID } from '~/types/common';

import { type SitesAdminQueryParams } from './useQuerySitesAdmin';

/**
 * Query key factory for site-related queries.
 */
export const queryKeysSite = {
  base: () => 'site' as const,
  getAllAdmin: (queryParams: SitesAdminQueryParams) =>
    [queryKeysSite.base(), 'list', 'admin', queryParams] as const,
  getBulkAdmin: (ids: UUID[]) =>
    [queryKeysSite.base(), 'bulkAdmin', { ids }] as const,
} as const;
